import React, { useCallback, useEffect, useState } from "react";
import { apiKey } from "../../config/config";
import axios from "axios";
import MessageCard from "../AdminCards/MessageCard";
import { FaLocationCrosshairs } from "react-icons/fa6";
import { languageHelper } from "../../config/helperFunctions";

function LocationModal({ closeModal }) {
  const [selectedOrderType, setSelectedOrderType] = useState(1);
  const [outletCities, setOutletCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [outlets, setOutlets] = useState([]);
  const [selectedOutlet, setSelectedOutlet] = useState(null);
  // const [selectedOutletName, setSelectedOutletName] = useState(null);
  const [error, setError] = useState(false);

  const handleSelect = () => {
    if (!selectedOutlet) {
      setError("Outlet Required!");
      return;
    }
    const data = {
      orderType: selectedOrderType,
      outlet: JSON.parse(selectedOutlet),
    };
    localStorage.setItem("rms-outlet", JSON.stringify(data));

    // Dispatch a custom event
    window.dispatchEvent(new Event("storageUpdated"));
    closeModal();
  };

  const fetchOutletCities = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/customer/outletCities`)
      .then((res) => {
        setOutletCities(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const fetchOutlets = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/customer/get-outlets`, {
        params: {
          orderTypeId: selectedOrderType,
          cityId: selectedCity,
          activeOrdertypes: true,
        },
      })
      .then((res) => {
        setOutlets(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedCity, selectedOrderType]);

  useEffect(() => {
    fetchOutletCities();
  }, [fetchOutletCities]);

  useEffect(() => {
    fetchOutlets();
  }, [fetchOutlets]);
  return (
    <>
      <div className="w-screen min-h-screen overlfow-y-scroll fixed top-0 left-0 backdrop-blur-2xl bg-black bg-opacity-40 z-50 grid place-items-center">
        <div className="bg-white max-w-2xl w-full overflow-y-auto rounded-xl px-2 py-4">
          <div className="my-2">
            <img className="mx-auto w-36" src="/imdady_logo.png" alt="" />
          </div>
          <div className="my-4 w-full">
            <h1 className="font-bold text-center text-w-heading">
              {languageHelper("select your order type") ||
                "Select your order type"}
            </h1>
            <div className="w-full my-4">
              <div className="w-full">
                <div className="flex justify-center gap-2 text-w-heading">
                  <button
                    className={`p-2 rounded border border-w-border ${
                      selectedOrderType === 1 &&
                      "bg-w-btn border-none text-w-btn-text"
                    }`}
                    onClick={() => setSelectedOrderType(1)}
                  >
                    {languageHelper("dine-in")}
                  </button>
                  <button
                    className={`p-2 rounded border border-w-border ${
                      selectedOrderType === 2 &&
                      "bg-w-btn border-none text-w-btn-text"
                    }`}
                    onClick={() => setSelectedOrderType(2)}
                  >
                    {languageHelper("delivery") || "DELIVERY"}
                  </button>
                  <button
                    className={`p-2 rounded border border-w-border ${
                      selectedOrderType === 3 &&
                      "bg-w-btn border-none text-w-btn-text"
                    }`}
                    onClick={() => setSelectedOrderType(3)}
                  >
                    {languageHelper("takeaway") || "TAKEAWAY"}
                  </button>
                </div>
                <div className="my-4 w-full">
                  <div className="max-w-md mx-auto">
                    <h2 className="text-center text-w-heading font-medium">
                      {selectedOrderType === 2
                        ? languageHelper("please select your location") ||
                          "Please select your location"
                        : selectedOrderType === 1
                        ? languageHelper(
                            "which outlet would you like to dine-in?"
                          ) || "Which outlet would you like to dine-in?"
                        : languageHelper(
                            "which outlet would you like to pick-up from?"
                          ) || "Which outlet would you like to pick-up from?"}
                    </h2>
                    <button className="flex gap-2 items-center justify-center rounded-full bg-gray-100 px-6 my-2 py-1 mx-auto text-sm text-gray-600 hover:bg-w-btn hover:text-w-btn-text group">
                      <span>
                        <FaLocationCrosshairs />
                      </span>
                      <span>
                        {languageHelper("use current location") ||
                          "Use Current Location"}
                      </span>
                    </button>
                    <div>
                      <form action="">
                        <select
                          className="w-full bg-white border p-2 rounded-md text-gray-500 my-2"
                          name=""
                          id=""
                          onChange={(e) => {
                            setSelectedCity(e.target.value);
                          }}
                        >
                          <option selected>
                            {languageHelper("select city/region") ||
                              "Select City/Region"}
                          </option>
                          {outletCities.map((city, index) => (
                            <option key={index} value={city.city_id}>
                              {city.name_en}
                            </option>
                          ))}
                        </select>
                        <select
                          className="w-full bg-white border p-2 rounded-md text-gray-500 my-2"
                          name=""
                          id=""
                          onChange={(e) => {
                            setSelectedOutlet(e.target.value);
                          }}
                        >
                          <option selected>
                            {languageHelper("select area/branch") ||
                              "Select Area/Branch"}
                          </option>
                          {outlets.map((outlet, index) => (
                            <option key={index} value={JSON.stringify(outlet)}>
                              {outlet.name}
                            </option>
                          ))}
                        </select>
                        {error && <MessageCard error={error} />}
                        <button
                          type="button"
                          className={`w-full text-center rounded-md p-2 my-2 text-w-btn-text bg-w-btn`}
                          onClick={handleSelect}
                        >
                          {languageHelper("select") || "Select"}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LocationModal;
